import { GraduationCap, Award, Briefcase, Hospital } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const PORTRAIT = "/ritratto.jpg";

const timeline = [
  { year: "2026 — oggi", title: "Attività privata a Torino", detail: "Studio in Corso Trapani 150. Psicologo presso il Centro Clinico Psicoanalitico Forbas.", icon: Briefcase },
  { year: "2023 — oggi", title: "Scuola di Specializzazione CIPA", detail: "Centro Italiano Psicologia Analitica — formazione quadriennale in psicoterapia junghiana.", icon: GraduationCap },
  { year: "2023 — oggi", title: "Tirocinio — Ser.D. Via Montevideo", detail: "Tirocinio formativo presso il Servizio per le Dipendenze patologiche, ASL Città di Torino.", icon: Hospital },
  { year: "2023 — oggi", title: "Psicoterapia online", detail: "Collaborazione con Unobravo, servizio di psicoterapia online.", icon: Briefcase },
  { year: "2021", title: "Abilitazione e Albo", detail: "Abilitazione all'esercizio della professione e iscrizione all'Albo degli Psicologi del Lazio.", icon: Award },
  { year: "2021", title: "Tirocinio — Centro di Salute Mentale", detail: "Tirocinio formativo presso il Centro di Salute Mentale, ASL Roma 2.", icon: Hospital },
  { year: "2021", title: "Tirocinio — Comunità Psichiatrica", detail: "Tirocinio formativo presso la Comunità Psichiatrica Residenziale \"Il Ponte e l'Albero\", ASL Roma 2.", icon: Hospital },
  { year: "2019 — 2021", title: "Laurea Magistrale", detail: "Psicologia dello Sviluppo Tipico e Atipico — Università Pontificia Salesiana, Roma.", icon: GraduationCap },
  { year: "2016 — 2019", title: "Laurea Triennale", detail: "Psicologia — Università Pontificia Salesiana, Roma.", icon: GraduationCap },
];

export const ChiSono = () => (
  <section id="chi-sono" data-testid="chi-sono-section" className="py-24 sm:py-32 lg:py-40 relative">
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-16">
      <div className="md:col-span-5">
        <Reveal>
          <Overline>Chi sono</Overline>
          <h2 className="font-serif tracking-tight leading-snug text-3xl sm:text-4xl lg:text-5xl text-sand">
            Un ascolto che va <span className="italic text-gold">oltre le parole</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="relative mt-12 max-w-[280px] sm:max-w-[320px]">
            <div className="absolute -inset-3 rounded-full border border-gold/30 translate-x-3 translate-y-3" />
            <div className="relative rounded-full overflow-hidden aspect-square bg-ink-soft border border-gold/20">
              <img
                src={PORTRAIT}
                alt="Dott. Andrea Moretti — Psicologo e psicoterapeuta in formazione junghiana a Torino"
                loading="lazy"
                decoding="async"
                width="1024"
                height="1024"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                data-testid="chi-sono-portrait"
              />
            </div>
            <div className="mt-6 text-center">
              <p className="font-serif text-xl text-sand">Dott. Andrea Moretti</p>
              <p className="text-xs uppercase tracking-[0.25em] text-gold mt-1.5">Albo degli Psicologi · dal 2021</p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="md:col-span-7">
        <Reveal delay={0.1}>
          <p className="text-base sm:text-lg text-sand-muted leading-relaxed">
            Nato a Roma nel 1995, mi sono formato in psicologia all'Università Pontificia
            Salesiana e oggi vivo e lavoro a Torino. Sono psicologo iscritto all'Albo e
            psicoterapeuta in formazione presso il{" "}
            <span className="text-sand">CIPA — Centro Italiano Psicologia Analitica</span>, la
            scuola che in Italia custodisce l'eredità di Carl Gustav Jung.
          </p>
          <p className="mt-5 text-base sm:text-lg text-sand-muted leading-relaxed">
            Il mio lavoro parte da un'idea semplice: ogni disagio porta con sé un significato che
            chiede di essere ascoltato. Insieme alla persona esploro i processi inconsci,
            l'analisi dei sogni e il lavoro simbolico, accompagnandola nei momenti di crisi e nel
            proprio percorso di crescita e individuazione.
          </p>
          <p className="mt-5 text-base sm:text-lg text-sand-muted leading-relaxed">
            Faccio parte del <span className="text-sand">Centro Clinico Psicoanalitico Forbas</span> di
            Torino e collaboro con <span className="text-sand">Unobravo</span> per la terapia online.
          </p>
        </Reveal>

        <div className="mt-14 relative pl-8 border-l border-gold/25" data-testid="cv-timeline">
          {timeline.map((t, i) => (
            <Reveal key={t.title} delay={i * 0.06} className="relative pb-10 last:pb-0">
              <span className="absolute -left-[41px] top-1 w-[18px] h-[18px] rounded-full bg-ink border border-gold flex items-center justify-center">
                <span className="w-1.5 h-1.5 rounded-full bg-gold" />
              </span>
              <p className="text-xs uppercase tracking-[0.25em] text-gold-bronze">{t.year}</p>
              <h3 className="font-serif text-xl text-sand mt-1.5">{t.title}</h3>
              <p className="text-sm text-sand-muted mt-1.5 leading-relaxed">{t.detail}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
